import { $ } from './dom';
import { warn } from './log';
import { isZone, toIana } from './time';

const warned = new Set<string>();
/** IANA name for `key`, null for "client" (browser-local), undefined when Intl rejects it (warned once per value). */
const zoneOf = (key: string) => {
  if (key.toLowerCase() === 'client') return null;
  const iana = toIana(key);
  if (isZone(iana)) return iana;
  if (!warned.has(key)) {
    warned.add(key);
    warn(`unknown timezone "${key}" → using the page default`);
  }
  return undefined;
};

/** data-tz on/above any of `nodes` wins, then the page's [data-date-timezone], then PT. An unknown value falls back to the next. */
export const resolveZone = (...nodes: Array<Element | null | undefined>): string | null => {
  const tzEl = $('[data-date-timezone]');
  const page = tzEl?.getAttribute('data-date-timezone')?.trim() || tzEl?.textContent?.trim() || 'PT';
  const own = nodes.map((n) => n?.closest('[data-tz]')?.getAttribute('data-tz')?.trim()).find(Boolean);
  for (const key of own ? [own, page] : [page]) {
    const zone = zoneOf(key);
    if (zone !== undefined) return zone;
  }
  return toIana('PT');
};
